import React from 'react';

const Media = ({ name }) => <img height="24px" width="24px" src={`/assets/img/media/${name}.png`} alt={name} />;

export default Media;
